import {message} from 'antd';
import {getIntl, RequestResponse, ResponseError} from 'umi';
import get from 'lodash/get';

export function getFromAndToDate(date) {
  return {
    from: date.start,
    to: date.end
  };
}


interface RequestCallbacks {
  onError?: (error?: ResponseError) => void,
  onSuccess?: (data: any) => void | any,
  onEnd?: () => void,
  defaultErrorMessage?: string
  showErrorMessage?: boolean
  successMessage?: string
  showSuccessMessage?: boolean
  successEntity?: string
}

/**
 * Extract a human-readable message from an API error body. Handles both the
 * legacy shape (`{error: {message}}` / `{error: {error}}`) and the Laravel
 * shape (`{error: "No record found for CalendarEvent"}` — a plain string).
 */
export function getAPIErrorMessage(data: any, fallback?: string): string {
  return (
    data?.message ||
    data?.error?.message ||
    data?.error?.error ||
    (typeof data?.error === 'string' ? data.error : '') ||
    fallback ||
    getIntl().formatMessage({id: 'pages.common.serverError', defaultMessage: 'There was an error processing your request.'})
  );
}

export function* processAPIResponse({response, data}: RequestResponse, options : RequestCallbacks = {}, dataKey?: string) {
  const {
    onError,
    onSuccess,
    onEnd,
    showErrorMessage,
    successMessage,
    showSuccessMessage,
    successEntity,
  } = options;

  let {defaultErrorMessage} = options;

  onEnd && onEnd()
  if (!defaultErrorMessage)
    defaultErrorMessage = getIntl().formatMessage({id: 'pages.common.serverError', defaultMessage: 'There was an error processing your request.'})
  try {
    if (response.status >= 200 && response.status < 300) {
      if (showSuccessMessage || successMessage) {
        const entityName = successEntity
          ? getIntl().formatMessage({id: `entity.${successEntity}.singular`, defaultMessage: successEntity})
          : '';
        message.success({
          content: successMessage || getIntl().formatMessage({id: 'common.entity.edit_success', defaultMessage: 'Saved successfully'}, {entity: entityName}),
          key: 'process_api_success',
        });
      }
      if (onSuccess)
        yield onSuccess(dataKey ? get(data, dataKey) : data);
    } else {
      if (!onError || showErrorMessage) {
        message.error(getAPIErrorMessage(data, defaultErrorMessage));
      } else {
        yield onError(data)
      }
    }
  } catch (e) {
    if (!onError) {
      let errorMessage = "Error"
      if (data) {
        errorMessage = data.message
        if (!errorMessage) return
      }
      message.error(errorMessage);
    } else {
      yield onError(data)
    }
  }

}

export function processAPIResponseNow(Response: RequestResponse, options : RequestCallbacks = {}, dataKey?: string) {
  const iterator = processAPIResponse(Response, options, dataKey);
  for (let step = iterator.next(); !step.done; step = iterator.next()) {
  }
}
